import { SortingOption } from '~src/shared/sortSelector/SortSelector';

import { SortingValues } from './filterAndSortingKeys';

export const participantSortingOptions = (): SortingOption[] => [
  {
    name: SortingValues.ResponseRate_desc,
    translationKey: 'x.reports.participant.sorting.response_rate.desc',
  },
  {
    name: SortingValues.ResponseRate_asc,
    translationKey: 'x.reports.participant.sorting.response_rate.asc',
  },
  {
    name: SortingValues.Fullname_asc,
    translationKey: 'x.reports.participant.sorting.participant_fullname.asc',
  },
  {
    name: SortingValues.Fullname_desc,
    translationKey: 'x.reports.participant.sorting.participant_fullname.desc',
  },
  {
    name: SortingValues.Lastname_asc,
    translationKey: 'x.reports.participant.sorting.participant_lastname.asc',
  },
  {
    name: SortingValues.Lastname_desc,
    translationKey: 'x.reports.participant.sorting.participant_lastname.desc',
  },
  {
    name: SortingValues.LastMail_desc,
    translationKey: 'x.reports.participant.sorting.last_mail.asc',
  },
  {
    name: SortingValues.LastMail_asc,
    translationKey: 'x.reports.participant.sorting.last_mail.desc',
  },
];

export const topicSortingOptions = (locale: string): SortingOption[] => [
  {
    name: SortingValues.LastAnswered_asc,
    translationKey: 'x.reports.topics.sorting.least_recent',
  },
  {
    name: SortingValues.LastAnswered_desc,
    translationKey: 'x.reports.topics.sorting.most_recent',
  },
  {
    name: SortingValues.MostAnswered_desc,
    translationKey: 'x.reports.topics.sorting.most_answered',
  },
  {
    name: SortingValues.MostAnswered_asc,
    translationKey: 'x.reports.topics.sorting.least_answered',
  },
  {
    name: `${SortingValues.TopicNames_asc}.${locale}`,
    translationKey: 'x.reports.topics.sorting.AtoZ',
  },
  {
    name: `${SortingValues.TopicNames_desc}.${locale}`,
    translationKey: 'x.reports.topics.sorting.ZtoA',
  },
];

export const questionSortingOptions = (locale: string): SortingOption[] => [
  {
    name: SortingValues.DefaultString_asc,
    translationKey: 'x.reports.topics.sorting.default',
  },
  {
    name: SortingValues.Rating_desc,
    translationKey: 'x.reports.topics.sorting.most_rating',
  },
  {
    name: SortingValues.Rating_asc,
    translationKey: 'x.reports.topics.sorting.least_rating',
  },
  {
    name: SortingValues.LastAnswered_desc,
    translationKey: 'x.reports.topics.sorting.last_updated',
  },
  {
    name: SortingValues.LastAnswered_asc,
    translationKey: 'x.reports.topics.sorting.least_updated',
  },
  {
    name: SortingValues.Answered_desc,
    translationKey: 'x.reports.topics.sorting.most_answered',
  },
  {
    name: SortingValues.Answered_asc,
    translationKey: 'x.reports.topics.sorting.least_answered',
  },
  {
    name: `${SortingValues.QuestionText_asc}.${locale}`,
    translationKey: 'x.reports.topics.sorting.AtoZ',
  },
  {
    name: `${SortingValues.QuestionText_desc}.${locale}`,
    translationKey: 'x.reports.topics.sorting.ZtoA',
  },
];

export const improveSortingOptions = (locale: string): SortingOption[] => [
  {
    name: SortingValues.Rating_desc,
    translationKey: 'x.reports.topics.sorting.most_rating',
  },
  {
    name: SortingValues.Rating_asc,
    translationKey: 'x.reports.topics.sorting.least_rating',
  },
  {
    name: SortingValues.LastAnswered_asc,
    translationKey: 'x.reports.topics.sorting.last_updated',
  },
  {
    name: SortingValues.LastAnswered_desc,
    translationKey: 'x.reports.topics.sorting.least_updated',
  },
  {
    name: SortingValues.Answered_desc,
    translationKey: 'x.reports.topics.sorting.most_answered',
  },
  {
    name: SortingValues.Answered_asc,
    translationKey: 'x.reports.topics.sorting.least_answered',
  },
  {
    name: `${SortingValues.QuestionText_asc}.${locale}`,
    translationKey: 'x.reports.topics.sorting.AtoZ',
  },
  {
    name: `${SortingValues.QuestionText_desc}.${locale}`,
    translationKey: 'x.reports.topics.sorting.ZtoA',
  },
];

export const answerSortingOptions = (): SortingOption[] => [
  {
    name: SortingValues.LastAnswered_desc,
    translationKey: 'x.reports.topics.sorting.latest',
  },
  {
    name: SortingValues.LastAnswered_asc,
    translationKey: 'x.reports.topics.sorting.oldest',
  },
  {
    name: SortingValues.Rating_desc,
    translationKey: 'x.reports.topics.sorting.most_rating',
  },
  {
    name: SortingValues.Rating_asc,
    translationKey: 'x.reports.topics.sorting.least_rating',
  },
];

export const myTeamSortingOptions: SortingOption[] = (() => {
  const key = 'x.reports.user.my_team.list.sorting';
  return [
    {
      name: SortingValues.Fullname_asc,
      translationKey: `${key}.name_AtoZ`,
    },
    {
      name: SortingValues.Fullname_desc,
      translationKey: `${key}.name_ZtoA`,
    },
    {
      name: SortingValues.Lastname_asc,
      translationKey: `${key}.last_name_AtoZ`,
    },
    {
      name: SortingValues.Lastname_desc,
      translationKey: `${key}.last_name_ZtoA`,
    },
  ];
})();

export const directSortingOptions: SortingOption[] = [
  {
    name: SortingValues.Created_desc,
    translationKey: 'x.reports.topics.sorting.most_recent',
  },
  {
    name: SortingValues.Created_asc,
    translationKey: 'x.reports.topics.sorting.least_recent',
  },
];

export const directTypeFilteringOptions: SortingOption[] = [
  {
    name: 'all',
    translationKey: 'x.reports.direct.feedback.filter.all',
  },
  {
    name: 'praise',
    translationKey: 'x.reports.direct.feedback.filter.praise',
  },
  {
    name: 'hint',
    translationKey: 'x.reports.direct.feedback.filter.hint',
  },
];

export const topicsAndQuestionsSortingOptions = (): SortingOption[] => [
  {
    name: SortingValues.TopicNames_asc,
    translationKey: 'x.reports.topics.sorting.AtoZ',
  },
  {
    name: SortingValues.TopicNames_desc,
    translationKey: 'x.reports.topics.sorting.ZtoA',
  },
  {
    name: SortingValues.Created_asc,
    translationKey: 'x.reports.topics.sorting.least_recent',
  },
  {
    name: SortingValues.Created_desc,
    translationKey: 'x.reports.topics.sorting.most_recent',
  },
];

export const keyResultsSortOptions = (locale: string): SortingOption[] => [
  {
    name: SortingValues.Created_desc,
    translationKey: 'x.okrs.key_results.sorting.most_recent',
  },
  {
    name: `${SortingValues.Name_asc}.${locale}`,
    translationKey: 'x.okrs.key_results.sorting.AtoZ',
  },
  {
    name: `${SortingValues.Name_desc}.${locale}`,
    translationKey: 'x.okrs.key_results.sorting.ZtoA',
  },
  {
    name: SortingValues.Last_modified,
    translationKey: 'x.okrs.key_results.sorting.last_modified',
  },
  {
    name: SortingValues.Progress_asc,
    translationKey: 'x.okrs.key_results.sorting.progress_rate',
    icon: 'upArrow',
  },
  {
    name: SortingValues.Progress_desc,
    translationKey: 'x.okrs.key_results.sorting.progress_rate',
    icon: 'downArrow',
  },
];

export type CompletionTabSortOptionNames = SortingValues.ManagerFinishedAt_asc |
  SortingValues.ManagerFinishedAt_desc |
  SortingValues.UserFinishedAt_asc |
  SortingValues.UserFinishedAt_desc |
  SortingValues.Firstname_asc |
  SortingValues.Firstname_desc;

export const completionTabSortOptions = (): SortingOption<CompletionTabSortOptionNames>[] => [
  {
    name: SortingValues.Firstname_asc,
    translationKey: 'x.okrs.key_results.sorting.AtoZ',
  },
  {
    name: SortingValues.Firstname_desc,
    translationKey: 'x.okrs.key_results.sorting.ZtoA',
  },

  {
    name: SortingValues.ManagerFinishedAt_asc,
    translationKey: 'admin.feedback.cycle.sorting.manager.completion.date.asc',
  },
  {
    name: SortingValues.ManagerFinishedAt_desc,
    translationKey: 'admin.feedback.cycle.sorting.manager.completion.date.desc',
  },
  {
    name: SortingValues.UserFinishedAt_asc,
    translationKey: 'admin.feedback.cycle.sorting.user.completion.date.asc',
  },
  {
    name: SortingValues.UserFinishedAt_desc,
    translationKey: 'admin.feedback.cycle.sorting.user.completion.date.desc',
  },
];
